module.exports = __webpack_public_path__ + "img/14.37d927ea.jpg";